<template>
    <div>
        <img :src="src" :alt="alt">
        <div class="mt-1">
            <div class="d-flex justify-center">
                <img class="mr-1" src="../assets/img/circleitem_title_icon.svg" alt="">
                <b><slot></slot></b>
                <img class="ml-1" src="../assets/img/circleitem_title_icon.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:[
        "src",
        "alt"
    ]
}
</script>